"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.normalizePhone = function (value) {
  var num = value.replace(/[^\d]/g, "");
  num = "+1" + num;
  return num;
};

exports.displayPhone = function (value, previousValue) {
  if (!value) {
    return value;
  }

  var withoutCountry = value.replace("+1", "");
  var onlyNums = withoutCountry.replace(/[^\d]/g, "");

  if (!previousValue || value.length > previousValue.length) {
    if (onlyNums.length === 3) {
      return "(" + onlyNums + ") ";
    }

    if (onlyNums.length === 6) {
      return "(" + onlyNums.slice(0, 3) + ") " + onlyNums.slice(3) + "-";
    }
  }

  if (onlyNums.length === 0) {
    return "";
  }

  if (onlyNums.length <= 3) {
    return "(" + onlyNums;
  }

  if (onlyNums.length <= 6) {
    return "(" + onlyNums.slice(0, 3) + ") " + onlyNums.slice(3);
  }

  if (onlyNums.length <= 10) {
    return "(" + onlyNums.slice(0, 3) + ") " + onlyNums.slice(3, 6) + "-" + onlyNums.slice(6, 10);
  } else {
    return "(" + onlyNums.slice(0, 3) + ") " + onlyNums.slice(3, 6) + "-" + onlyNums.slice(6, 10) + " x" + onlyNums.slice(10);
  }
};